// extracted by mini-css-extract-plugin
export default {"task":"WorkflowTask_task__HYAMo","text":"WorkflowTask_text__wRMHn","box":"WorkflowTask_box__qY4ky","endpoint":"WorkflowTask_endpoint__szBdY","active":"WorkflowTask_active__FvJdZ"};